import { Popover, Modal } from 'ionic-angular';

export enum PriorityLevel {
    Error,
    Warning,
    Notification
}

export interface SecondaryButton {
    text: string;
    callback: Function;
}

export interface NotificationResult {
    primaryClicked?: boolean;
    doNotShowAgain?: boolean;
}

export interface PopupTrackingObject {
    componentName: string;
    component: Modal | Popover;
}

export interface ModalProperties {
    priority?: PriorityLevel;
    title: string;
    message: string;
    primaryText: string;
    primaryButtonCSS?: string;
    secondaryButtons?: SecondaryButton[];
    materialIconName?: string;
    customCSS?: string;
}



// WEBPACK FOOTER //
// ./src/providers/popup/base.ts